import { Controller } from "stimulus"

export default class extends Controller {
  toggle() {
    $(".js-toggle-clue-provide-biz-director").toggle();
  }
}
